import { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CampaignTabs from "../../components/CampaignTabs";
import WaitTab from "./WaitTab";
import InprogressTab from "./InprogressTab";
import CompleteTab from "./CompleteTab";
import ReusableSearchBar from "../../components/ReusableSearchBar";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { contentsCompletion, contentsPending, contentsReview } from "../../api";

export default function ContentsPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // 탭 → API 매핑
  const apiMap = {
    wait: contentsPending,
    inprogress: contentsReview,
    complete: contentsCompletion,
  };

  // URL 기반 현재 탭 찾기
  const currentTab = Object.keys(apiMap).find((key) => pathname.includes(key));

  // 리스트 상태
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [counts, setCounts] = useState();

  // 검색
  const [keyword, setKeyword] = useState("");

  // 공통 API 호출 함수
  const loadItems = async () => {
    try {
      setLoading(true);

      const apiFn = apiMap[currentTab];
      if (!apiFn) return;

      const res = await apiFn();

      setCounts(res?.data?.counts);
      setItems(res?.data?.campaigns ?? []); // 반드시 추가!
    } catch (e) {
      console.error("loadItems error:", e);
    } finally {
      setLoading(false);
    }
  };

  // 탭 변경 시 초기화 + 첫 페이지 로드
  useEffect(() => {
    setItems([]);
    setPage(1);
    setKeyword("");

    loadItems();
    // eslint-disable-next-line
  }, [currentTab]);

  // page 증가 시 추가 로딩
  useEffect(() => {
    if (page > 1) loadItems();
    // eslint-disable-next-line
  }, [page]);

  // 검색 필터링
  const filtered = items.filter((c) => {
    const text = c.campaignTitle;

    return text?.toLowerCase().includes(keyword.toLowerCase());
  });

  const campaignProps = {
    list: filtered,
    loading,
  };

  const tabs = [
    { label: `검수 대기 (${counts?.pendingsubmission ?? 0})`, path: "wait" },
    { label: `검수중 (${counts?.underreview ?? 0})`, path: "inprogress" },
    { label: `검수 완료 (${counts?.completion ?? 0})`, path: "complete" },
  ];

  const title = ["컨텐츠 검수 대기 목록", "검수중인 목록", "검수 완료된 목록"];
  const desc = [
    "콘텐츠 제작 진행중인 목록입니다. 크리에이터가 콘텐츠를 등록하면 검수중으로 넘어갑니다.",
    "크리에이터가 등록한 콘텐츠를 확인하고 승인/반려 또는 피드백을 남길 수 있습니다.",
    "검수가 완료된 콘텐츠 목록입니다. 승인된 콘텐츠는 광고 게시가 가능합니다.",
  ];

  const activeIndex = tabs.findIndex((t) => pathname.includes(t.path));
  const onTabChange = (index) => {
    navigate(`/contents/${tabs[index].path}`);
  };

  return (
    <Flex flexDir="column" h="100%">
      <Flex justify="space-between" alignItems="center" mb="24px">
        <CampaignTabs
          tabLabels={tabs.map((t) => t.label)}
          onChange={onTabChange}
          activeIndex={activeIndex}
        />
        <ReusableSearchBar
          placeholder="정산 검색"
          width="229px"
          onSearch={(v) => setKeyword(v)}
        />
      </Flex>
      <Box mb="16px">
        <Text fontSize="xl" fontWeight="bold" mb="2">
          {title[activeIndex]}
        </Text>
        <Text color="gray.600" mb="6">
          {desc[activeIndex]}
        </Text>
      </Box>
      <Routes>
        <Route path="wait/*" element={<WaitTab {...campaignProps} />} />
        <Route
          path="inprogress/*"
          element={<InprogressTab {...campaignProps} />}
        />
        <Route path="complete/*" element={<CompleteTab {...campaignProps} />} />
        <Route path="*" element={<Navigate to="wait" replace />} />
      </Routes>
    </Flex>
  );
}
